import React, { useEffect, useState } from 'react';
import { AMOUNT_PRESETS } from '../../data/program';
import { useProto } from '../../contexts/PrototypeContext';
import { FieldTag } from '../shared/FieldTag';
import { Annotation } from '../shared/Annotation';
export function DiscountAmountField() {
  const {
    state,
    actions
  } = useProto();
  const amount = state.config.amount;
  const [text, setText] = useState(amount ? String(amount) : '');
  useEffect(() => {
    if ((parseFloat(text) || 0) !== amount) setText(amount ? String(amount) : '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount]);
  const invalid = !(amount > 0);
  return <div data-id="element-62" data-mp="1fzgzf7frdiuf">
      <div className="flex items-center gap-2" data-id="element-63" data-mp="1fwupj15ear91">
        <label htmlFor="vrd-amount" className="font-medium text-connect-ink" data-id="element-64" data-mp="1b15mgnu62s7z">Volunteer Registration Discount Amount</label>
        <FieldTag kind="editable" data-id="element-65" data-mp="160hy69xbophg" />
      </div>
      <p className="mt-0.5 text-sm text-connect-muted" data-id="element-66" data-mp="11zo9hec236ni">One amount for the entire program, shared across all volunteer roles.</p>

      <div className="mt-3 flex flex-wrap items-end gap-6" data-id="element-67" data-mp="273ke3273ox13">
        <div className="relative w-40" data-id="element-68" data-mp="2bvbw2oc6xufm">
          <span className="absolute bottom-2 left-0 text-lg text-connect-ink" aria-hidden="true" data-id="element-69" data-mp="2bwdghjf3jta0">$</span>
          <input id="vrd-amount" inputMode="decimal" value={text} placeholder="0.00" aria-invalid={invalid} aria-describedby={invalid ? 'vrd-amount-err' : undefined} onChange={e => {
          const v = e.target.value.replace(/[^0-9.]/g, '');
          setText(v);
          actions.updateConfig({
            amount: Math.round((parseFloat(v) || 0) * 100) / 100
          });
        }} className={`w-full border-0 border-b bg-transparent py-1.5 pl-4 text-lg text-connect-ink outline-none focus:border-b-2 ${invalid ? 'border-connect-danger' : 'border-gray-400 focus:border-connect-blue'}`} data-id="element-70" data-mp="1x7qrsr3kxp64" />
        </div>
        <div role="group" aria-label="Quick select amount" className="flex items-center gap-2" data-id="element-71" data-mp="19eie55q8vzgj">
          <span className="text-xs text-connect-muted" data-id="element-72" data-mp="3c5ldd3m5fh1m">Quick select</span>
          {AMOUNT_PRESETS.map(p => {
          const selected = amount === p;
          return <button key={p} type="button" aria-pressed={selected} onClick={() => actions.updateConfig({
            amount: p
          })} className={`rounded-full border px-3 py-1 text-sm transition-colors duration-150 ${selected ? 'border-connect-blue bg-connect-blue text-white' : 'border-connect-line text-connect-ink hover:border-connect-blue'}`} data-id="element-73" data-mp="32bw3jyulegij">
                ${p}
              </button>;
        })}
        </div>
      </div>
      {invalid && <p id="vrd-amount-err" className="mt-2 text-sm text-connect-danger" data-id="element-74" data-mp="hm6q9q9jf2ry">Enter an amount greater than $0.</p>}
      <Annotation kind="rule" title="One program-level amount" className="mt-3" data-id="element-75" data-mp="cp6i99t4npy7">
        Not configurable by role. An immediate discount against the current registration balance, applied once per volunteering customer per program regardless of children registered or teams coached. Never creates a negative balance or refundable value. No background check required before it's awarded.
      </Annotation>
    </div>;
}